"use client";

import { dynamicChart } from "@/components/charts/dynamicChart";

export type {
  WithdrawalsPoint,
  RefLine,
  PopulationPoint,
} from "./WithdrawalsChart.impl";

export const WithdrawalsChart = dynamicChart(
  () => import("./WithdrawalsChart.impl").then((m) => m.WithdrawalsChart),
  384,
);
